import React from 'react';
import { CreateBanner } from './CreateBanner';

const IMAGE = {
    MD: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a8dd456946047627d3603d051a103bff-1733851173710/sign-business-activation-md.png',
    LG: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/a8dd456946047627d3603d051a103bff-1733851173705/sign-business-activation-lg.png',
};

export const CodeActivationBanner = () => <CreateBanner imageSrcMd={IMAGE.MD} imageSrcLg={IMAGE.LG} />;
